// reducers.js
import { combineReducers } from 'redux';
import blogReducer from './reducers/blogReducer';;

const rootReducer = combineReducers({
  blogReducer,
});

export default rootReducer;